/* Translate controls only; never rewrite customer testimony. */
(function () {
 'use strict';
 if (!/^fr(?:-|$)/i.test(document.documentElement.lang)) return;
 const initialized = new WeakSet();
 function init(scope = document) {
  scope.querySelectorAll('[data-compact-reviews]').forEach(root => {
   if (initialized.has(root)) return;
   const widget = root.querySelector('#judgeme_product_reviews');
   const data = root.querySelector('[data-review-labels]');
   if (!widget || !data) return;
   let labels; try { labels = JSON.parse(data.textContent); } catch (_) { return; }
   initialized.add(root);
   const exact = {'More':labels.more,'Read more':labels.more,'Less':labels.less,'Read less':labels.less,'Show more reviews':labels.reviews,'Scroll thumbnails right':labels.next,'Scroll thumbnails left':labels.previous,'View review image':labels.image};
   function translate() {
    // Judge.me can mislabel its five-star summary as "out of 1"; keep the actual score.
    if (widget.getAttribute('data-id') === '8492868370771') {
     widget.querySelectorAll('.jm-star-rating[role="img"][aria-label]').forEach(stars => {
      const aria = stars.getAttribute('aria-label');
      const match = aria && aria.match(/^(\d+(?:[.,]\d+)?) out of 1 stars?$/i);
      if (match && Number(match[1].replace(',', '.')) <= 5) {
       stars.setAttribute('aria-label', match[1].replace('.', ',') + ' sur 5 étoiles');
      }
     });
    }
    widget.querySelectorAll('button,[role="button"]').forEach(control => {
     if (control.closest('.jm-review-content')) return;
     const walker = document.createTreeWalker(control, NodeFilter.SHOW_TEXT);
     let node; while ((node = walker.nextNode())) {
      const key = node.nodeValue.trim();
      if (exact[key]) node.nodeValue = node.nodeValue.replace(key, exact[key]);
     }
     const aria = control.getAttribute('aria-label');
     if (!aria) return;
     const product = aria.match(/^View (.+) product page$/);
     const item = aria.match(/^(?:Go to item|View image) (\d+)$/);
     const rating = aria.match(/^(\d+)% \((\d+)\) reviews with (\d) star rating$/);
     const translated = exact[aria] || (product && labels.product.replace('{product}',product[1])) || (item && labels.media.replace('{n}',item[1])) || (rating && labels.rating.replace('{percent}',rating[1]).replace('{count}',rating[2]).replace('{stars}',rating[3]));
     if (translated && translated !== aria) control.setAttribute('aria-label',translated);
    });
   }
   const observer = new MutationObserver(() => { observer.disconnect(); translate(); observe(); });
   function observe() { observer.observe(widget,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label']}); }
   translate(); observe();
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();